import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ReadDetail from '@/components/screens/read-detail/ReadDetail';
import { API_URL } from '@/helpers/variables';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IRead } from '@/interfaces/read.interface';
import useRedirectToBookPage from '@/hooks/useRedirectToBookPage';

interface IReviewsPage {
  book: IBookDetailData;
  read: IRead;
}

const ReadPage: NextPage<IReviewsPage> = ({ book, read }) => {
  useRedirectToBookPage(book.type);
  return <ReadDetail book={book} read={read} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const bookRes = await fetch(`${API_URL}satellite/books/${id}`);

  // Check fetch error
  if (!bookRes.ok) {
    console.table(`Error ${bookRes.status}. Api: ${bookRes.url}`);
    return {
      notFound: true,
    };
  }

  const book = await bookRes.json();

  // Check Fetched Data Error
  if (!book.id || book.book.external_uid === undefined) {
    return {
      notFound: true,
    };
  }

  const readRes = await fetch(
    book.book.allow_full_free > 0
      ? `${API_URL}read-online?external_uid=${book.book.external_uid}&alias=${book.book.alias}&secret=J%3F_k.Y%40z!6K1h%3D4~mC4!Fx]%2CTXJUZyt]`
      : `${API_URL}read-online?external_id=${book.book.external_id}&secret=J%3F_k.Y%40z!6K1h%3D4~mC4!Fx]%2CTXJUZyt]`
  ).catch((e) => {
    console.warn(e);
    return null;
  });

  // Check Fetched Data Error
  if (readRes?.status === 500) {
    return {
      notFound: true,
    };
  }
  const read = await readRes?.json();

  return { props: { book, read } };
};

export default ReadPage;
